"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BexApiSource = void 0;
var bernie_core_1 = require("bernie-core");
var mobx_1 = require("mobx");
var bernie_logger_1 = require("bernie-logger");
var client_1 = require("./client");
var withoutKeys = bernie_core_1.merge.withoutKeys;
var BexApiSource = /** @class */ (function () {
    function BexApiSource(apiOperationsFactory, clientConfigs, logger, headers) {
        if (clientConfigs === void 0) { clientConfigs = {}; }
        if (logger === void 0) { logger = bernie_logger_1.NOOP_LOGGER; }
        this.apiOperationsFactory = apiOperationsFactory;
        this.clientConfigs = clientConfigs;
        this.logger = logger;
        this.headers = headers;
        this.apiOperationsFactory = apiOperationsFactory;
    }
    Object.defineProperty(BexApiSource.prototype, "operations", {
        // Lazy load this so it happens after hydration (where appName should be copied from the server instance)
        get: function () {
            if (!this.apiOperations) {
                this.apiOperations = this.apiOperationsFactory((0, client_1.getClient)(this.logger, this.clientConfigs, this.headers));
            }
            return this.apiOperations;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Override the default `toJson` to exclude the Apollo client.
     * If we don't include this, we will get a JSON serialization error.
     *
     * Creates a basic JSON object from the store, excluding
     * any fields provided in `ignoreAdditionalKeys`.
     */
    BexApiSource.prototype.toJSON = function (ignoreAdditionalKeys) {
        if (ignoreAdditionalKeys === void 0) { ignoreAdditionalKeys = []; }
        if (!Array.isArray(ignoreAdditionalKeys)) {
            ignoreAdditionalKeys = ignoreAdditionalKeys.constructor === String ? [ignoreAdditionalKeys] : [];
        }
        var regexIgnorePrivate = /^_.+/;
        var simpleObject = (0, mobx_1.toJS)(this);
        var ignoreKeys = Object.keys(simpleObject)
            .filter(function (key) { return regexIgnorePrivate.test(key) || typeof simpleObject[key] === 'function'; })
            .concat(ignoreAdditionalKeys, 'logger', 'apiOperations', 'headers');
        return withoutKeys(ignoreKeys).merge({}, simpleObject);
    };
    return BexApiSource;
}());
exports.BexApiSource = BexApiSource;
//# sourceMappingURL=bex-api-source.js.map